import { render, staticRenderFns } from "./UserAnnounce.vue?vue&type=template&id=60c262b8&scoped=true"
import script from "./UserAnnounce.vue?vue&type=script&lang=js"
export * from "./UserAnnounce.vue?vue&type=script&lang=js"
import style0 from "./UserAnnounce.vue?vue&type=style&index=0&id=60c262b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c262b8",
  null
  
)

export default component.exports